import { message, Table } from 'antd';
import { CheckOutlined, CloseOutlined, EyeOutlined } from '@ant-design/icons';

import styles from './stylesPendingRequestsTable.module.css';

import moneyFormatter from '../../../../utils/MoneyFormatter';
import CustomPagination from '../../../CommonComponents/CustomPagination/CustomPagination';
import { useWithdrawalReview } from '../WithdrawalReviewContext';
import { convertToUserTimezone } from '../../../../utils/FormatDate';
import UserAvatar from '../../../CommonComponents/UserAvatar/UserAvatar';

function PendingRequestsTable() {
  const {
    pendingTransactions,
    handleViewUser,
    openDeclinedModal,
    openDetailsModal,
    handleApproved,

    pendingPageSize,
    setPendingPageSize,
    pendingCurrentPage,
    setPendingCurrentPage,
    pendingTotalCount,
    loadingPending,
  } = useWithdrawalReview();

  const handleApprovedRequests = (record) => {
    handleApproved(record);
    message.success('Withdrawal Approved');
  };

  const columns = [
    {
      title: 'Request Date',
      dataIndex: 'request_date_timestamp',
      key: 'request_date',
      width: 160,
      render: (text) => <span>{convertToUserTimezone(text)}</span>,
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      width: 150,
      render: (text, record) => (
        <div className={styles.userImage}>
          <UserAvatar userId={record.user_id} />
          <button onClick={() => handleViewUser(record)}>
            <span>{text}</span>
          </button>
        </div>
      ),
    },
    {
      title: 'Transaction ID',
      dataIndex: 'transaction_id',
      key: 'transaction_id',
      width: 250,
    },
    {
      title: 'Last Deposit Amount',
      dataIndex: 'last_deposit_amount',
      key: 'last_deposit_amount',
      width: 180,
      render: (text, record) => (
        <div className={styles.lastDepositCol}>
          <span>${moneyFormatter(text)}</span>
          <span className={styles.lastDepositColDate}>
            {convertToUserTimezone(record.last_deposit_date, 'MMM DD, HH:mm')}
          </span>
        </div>
      ),
    },
    {
      title: 'Withdrawal Amount',
      dataIndex: 'withdrawal_amount',
      key: 'withdrawal_amount',
      width: 160,
      render: (text) => <span>${moneyFormatter(text)}</span>,
    },
    {
      title: 'Payment Gateway',
      dataIndex: 'payment_gateway',
      key: 'payment_gateway',
      width: 150,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 140,
      fixed: 'right',
      render: (_, record) => (
        <div className={styles.actionButtonGroup}>
          <button
            className={`${styles.actionButton} ${styles.approve}`}
            onClick={() => handleApprovedRequests(record)}
          >
            <CheckOutlined />
          </button>

          <button
            className={`${styles.actionButton} ${styles.reject}`}
            onClick={() => openDeclinedModal(record)}
          >
            <CloseOutlined />
          </button>

          <button
            className={`${styles.actionButton} ${styles.details}`}
            onClick={() => openDetailsModal(record)}
          >
            <EyeOutlined />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        loading={loadingPending}
        columns={columns}
        dataSource={pendingTransactions?.transactions || []}
        pagination={false}
        scroll={{ x: 1000 }}
        rowKey={(record) => record.transaction_id}
        className={styles.customTable}
      />
      <CustomPagination
        total={pendingTotalCount || 0}
        pageSize={pendingPageSize}
        currentPage={pendingCurrentPage}
        onPageSizeChange={(value) => {
          setPendingPageSize(value);
        }}
        onPageChange={(page) => setPendingCurrentPage(page)}
      />
    </>
  );
}

export default PendingRequestsTable;
